let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hnP2X")).then(() => parcelRequire('2SuE2'));